export default "__VITE_ASSET__ByFl3vzb__"